"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zustand_1 = require("zustand");
const useFilter = (0, zustand_1.create)((set) => ({
    filter: {},
    setFilter: (id, filter) => set((state) => ({ filter: { ...state.filter, [id]: filter } }))
}));
exports.default = useFilter;
